import { makeStyles } from '@material-ui/core';
import { colors } from '../../../theme/color-palette';
import * as constants from '../../../constants/constant';
export const useCommonStyles = makeStyles(() => ({
	container: {
		width: (P) => P.chartWidth,
		border: `1px solid ${colors.LIGHT_GREY}`,
		borderRadius: '8px',
		height: '430px',
		margin: '8px',
	},
}));
const loaderStyles = {
	loader: {
		display: 'flex',
		height: '424px',
	},
	circularProgress: {
		margin: 'auto',
	},
};
// ItemBasicInfo
export const useBasicInfoStyles = makeStyles(() => ({
	breadCrumb: {
		marginLeft: 16,
		marginTop: 16,
	},
	info: {
		marginTop: 24,
		marginLeft: 16,
		height: 315,
	},
	supplier: {
		marginLeft: 16,
		height: 50,
		display: 'flex',
	},
	...loaderStyles,
}));
export const basicInfoStyles = {
	breadCrumb: {
		fontSize: 14,
		textAlign: 'left',
		color: colors.BLACK,
		fontFamily: constants.BOGLE_REGULAR,
	},
	itemName: {
		fontSize: 18,
		marginBottom: 24,
		textAlign: 'left',
		color: colors.BLACK,
		fontFamily: constants.BOGLE_REGULAR,
	},
	label: {
		fontSize: 14,
		textAlign: 'left',
		color: colors.BLACK,
		fontFamily: constants.BOGLE_REGULAR,
	},
	value: {
		fontSize: 16,
		textAlign: 'left',
		color: colors.BLACK,
		fontFamily: constants.BOGLE_REGULAR,
		marginBottom: 12,
	},
	supplierName: {
		fontSize: 14,
		margin: 'auto 0',
		color: colors.BLACK,
		fontFamily: constants.BOGLE_REGULAR,
	},
};
// Summary/Small cards
export const useSummaryCardsStyles = makeStyles(() => ({
	card: {
		border: `1px solid ${colors.LIGHT_GREY}`,
		borderRadius: '8px',
		height: '200px',
	},
	container: {
		justifyContent: 'space-between',
	},
	loader: {
		display: 'flex',
		height: '200px',
	},
	circularProgress: {
		margin: 'auto',
	},
	noData: {
		display: 'flex',
		height: '200px',
		flexDirection: 'column',
	},
}));
export const summaryCardsStyles = {
	title: {
		fontSize: 18,
		textAlign: 'left',
		marginLeft: 16,
		marginTop: 18,
		color: colors.FONT_COLOR,
		fontFamily: constants.BOGLE_REGULAR,
	},
	titleDate: {
		fontSize: 18,
		textAlign: 'left',
		marginTop: 18,
		color: colors.FONT_COLOR,
		fontFamily: constants.BOGLE_REGULAR,
	},
	value: {
		fontSize: 24,
		textAlign: 'left',
		marginLeft: 16,
		marginTop: 18,
		color: colors.FONT_COLOR,
		fontFamily: constants.BOGLE_REGULAR,
	},
	up: {
		color: colors.POSITIVE_GROWTH_COLOR,
		fontSize: 16,
		marginLeft: 16,
		marginTop: 8,
		fontFamily: constants.BOGLE_REGULAR,
	},
	down: {
		color: colors.NEGATIVE_GROWTH_COLOR,
		fontSize: 16,
		marginLeft: 16,
		marginTop: 8,
		fontFamily: constants.BOGLE_REGULAR,
	},
	topCard: {
		'@media (min-width: 1536px)': {
			maxWidth: '48% !important',
		},
		'@media (min-width: 600px) and (max-width: 1535px) ': {
			maxWidth: '24% !important',
		},
		'@media (max-width: 599px)': {
			maxWidth: '48% !important',
		},
	},
	bottomCard: {
		'@media (min-width: 1536px)': {
			maxWidth: '48% !important',
			marginTop: '24px !important',
		},
		'@media (min-width: 600px) and (max-width: 1535px) ': {
			maxWidth: '24% !important',
		},
		'@media (max-width: 599px)': {
			maxWidth: '48% !important',
			marginTop: '24px !important',
		},
	},
	noDataContent: {
		display: 'block',
		fontSize: '16px',
		color: colors.FONT_COLOR,
		fontFamily: constants.BOGLE_REGULAR,
		margin: 'auto',
	},
};
export const useMapSummaryStyles = makeStyles(() => ({
	header: {
		marginLeft: 16,
		marginTop: 16,
		display: 'flex',
		justifyContent: 'space-between',
	},
	loader: {
		display: 'flex',
		minHeight: '424px',
	},
	subLoader: {
		display: 'flex',
		height: '302px',
	},
	circularProgress: {
		margin: 'auto',
	},
	mapLeftContainer: {
		marginLeft: 18,
		marginTop: 18,
	},
	mapContainer: {
		margin: '0px',
		'& .gm-style a': {
			display: 'none !important',
		},
	},
	legend: {
		display: constants.INLINE_BLOCK,
		width: 400,
		height: 8,
		marginTop: 20,
		marginBottom: 20,
		background: 'linear-gradient(270deg, #54278f 0%, #f2f0f7 100%)',
		'@media (max-width: 1024px)': {
			width: '236px',
		},
	},
	actions: {
		display: 'flex',
		margin: 0,
		alignItems: 'center',
	},
	toggleButtonGroup: {
		marginBottom: 24,
		textTransform: 'none',
		'& .Mui-selected': {
			color: `${colors.PURPLE} !important`,
		},
		'& button': {
			padding: 8,
			fontSize: 12,
			fontWeight: 400,
			textTransform: 'unset',
			fontFamily: constants.BOGLE_REGULAR,
		},
	},
}));
export const mapSummaryStyles = {
	title: {
		fontSize: 18,
		textAlign: 'left',
		color: colors.FONT_COLOR,
		fontFamily: constants.BOGLE_REGULAR,
		cursor: 'pointer',
	},
	value: {
		fontSize: 24,
		textAlign: 'left',
		color: colors.FONT_COLOR,
		fontFamily: constants.BOGLE_MEDIUM,
		display: constants.INLINE_BLOCK,
		marginTop: 4,
	},
	yoy: {
		fontSize: 20,
		fontFamily: constants.BOGLE_LIGHT,
		display: constants.INLINE_BLOCK,
	},
	up: {
		color: colors.POSITIVE_GROWTH_COLOR,
	},
	down: {
		color: colors.NEGATIVE_GROWTH_COLOR,
	},
	yoyLabel: {
		marginLeft: 4,
		fontSize: 12,
		fontFamily: constants.BOGLE_LIGHT,
		display: constants.INLINE_BLOCK,
	},
	export: {
		marginTop: '-15%',
	},
	topAndBottomTitle: {
		fontSize: 14,
		fontWeight: 700,
		marginBottom: '16px',
		fontFamily: constants.BOGLE_MEDIUM,
	},
	topAndBottomText: {
		fontSize: 14,
		fontWeight: 400,
		marginBottom: '8px',
		fontFamily: constants.BOGLE_REGULAR,
	},
	legendContainer: {
		marginTop: '48px',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
	},
	legendLabel: {
		marginTop: '8px',
		fontSize: '12px',
		fontFamily: constants.BOGLE_REGULAR,
	},
	legendText: {
		marginBottom: '8px',
		fontSize: '12px',
		fontFamily: constants.BOGLE_REGULAR,
	},
	legendBlock: {
		width: '26px',
		height: '8px',
		marginRight: '2px',
	},
};
